import request from '@/utils/request'
import requestFile from '@/utils/request-file'
// 获取总览的数据
export function uploadTransTemplateExcel(config) {
  return requestFile({
    url: '/merchant-api/disbursement/excel/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: config.data,
    onUploadProgress: config.onUploadProgress

  })
}

// 查询是否是重复文件
export function checkoutFileIsSame(data = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/file/check',
    method: 'post',
    data
  })
}

// 获取所有批次
export function fetchDisbursementAllRefernceData(data = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/batchPage',
    method: 'post',
    data
  })
}

export function fetchDisbursementAllRefernceDataDownload(data = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/download',
    method: 'post',
    data
  })
}

export function fetchDisbursementRefernceDetail(data = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/ordersByBatchNo',
    method: 'post',
    data
  })
}

export function fetchDisbursementRefernceDetailWithTrans(params = {}) {
  return request({
    url: '/disbursement/excel/data/list',
    method: 'get',
    params
  })
}
export function disbursementRefernceCheck(data = {}) {
  return request({
    url: '/disbursement/excel/check/status',
    method: 'post',
    data
  })
}

export function disbursementRefernceConfirm(data = {}) {
  return request({
    url: '/disbursement/excel/confirm',
    method: 'post',
    data
  })
}

export function disbursementRefernceApprove(data = {}) {
  return request({
    url: '/disbursement/excel/approve',
    method: 'post',
    data
  })
}

export function updateDisbursementInfo(data = {}) {
  return request({
    url: '/disbursement/excel/data/update',
    method: 'post',
    data
  })
}

export function addSingleDisbursement(data = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/single',
    method: 'post',
    data
  })
}

// 删除详情
export function deleteDisbursementDetailData(data = {}) {
  return request({
    url: '/disbursement/excel/data/delete',
    method: 'delete',
    data
  })
}

// 删除批次
export function deleteDisbursementRefernceData(data = {}) {
  return request({
    url: '/disbursement/excel/delete',
    method: 'delete',
    data
  })
}

// 重试打款
export function retryDisbursementData(data = {}) {
  return request({
    url: '/disbursement/excel/data/retry',
    method: 'post',
    data
  })
}

export function uploadPaymentTransTemplateExcel(config) {
  return requestFile({
    url: '/payment/excel/upload',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data: config.data,
    onUploadProgress: config.onUploadProgress

  })
}

export function fetchPaymentRefernceDetail(data = {}) {
  return request({
    url: '/payment/excel/check',
    method: 'post',
    data
  })
}

export function addSinglePayment(data = {}) {
  return request({
    url: '/payment/excel/single',
    method: 'post',
    data
  })
}

export function deletePaymentRefernceData(data = {}) {
  return request({
    url: '/payment/excel/delete',
    method: 'delete',
    data
  })
}

export function deletePaymentDetailData(data = {}) {
  return request({
    url: '/payment/excel/data/delete',
    method: 'delete',
    data
  })
}

export function updatePaymentInfo(data = {}) {
  return request({
    url: '/payment/excel/data/update',
    method: 'post',
    data
  })
}

export function fetchPaymentRefernceDetailWithTrans(params = {}) {
  return request({
    url: '/payment/excel/data/list',
    method: 'get',
    params
  })
}

export function fetchPaymentAllRefernceData(params = {}) {
  return request({
    url: '/payment/excel/list',
    method: 'get',
    params
  })
}

export function paymentRefernceConfirm(data = {}) {
  return request({
    url: '/payment/excel/confirm',
    method: 'post',
    data
  })
}

export function fetchPaymentLinkTransDetail(params = {}) {
  return request({
    url: '/payment/excel/data/payment/list',
    method: 'get',
    params
  })
}

// get reference_batch_no
export function fetchReferenceBatchNo(params = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/generate/reference_batch_no',
    method: 'get',
    params
  })
}

export function sendPaymentEmail(data = {}) {
  return request({
    url: '/payment/excel/data/email',
    method: 'post',
    data
  })
}

export function getDisbursementBalance(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/getDisbursementBalance',
    method: 'post',
    data
  })
}

// 收款人 start

export function createLargeValueBeneficiary(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/createLargeValueBeneficiary',
    method: 'post',
    data
  })
}

export function editLargeValueBeneficiary(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/editLargeValueBeneficiary',
    method: 'post',
    data
  })
}

export function updateBeneficiaryShortName(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/updateBeneficiaryShortName',
    method: 'post',
    data
  })
}

export function queryLargeValueBeneficiaryList(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/queryLargeValueBeneficiaryList',
    method: 'post',
    data
  })
}

export function fetchLargeValueBeneficiaryAllList(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/queryAllBeneficiaryList',
    method: 'post',
    data
  })
}

export function queryLargeValueBeneficiaryDetail(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/queryLargeValueBeneficiaryDetail',
    method: 'post',
    data
  })
}

export function deleteLargeValueBeneficiary(data = {}) {
  return request({
    url: `/merchant-api/disbursement/large/deleteLargeValueBeneficiary/${data.id}`,
    method: 'post',
    data
  })
}

export function createLargeDisbursement(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/createDisbursement',
    method: 'post',
    data
  })
}

// 收款人 end
// 大额代付列表
export function queryLargeDisbursementList(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/queryDisbursementList',
    method: 'post',
    data
  })
}

// 小额代付列表
export function queryStandardList(params = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/data/page',
    method: 'get',
    params
  })
}

export function querySummaryStandardList(params = {}) {
  return request({
    url: '/merchant-api/disbursement/excel/data/data-summary',
    method: 'get',
    params
  })
}

// 多币种创建大额代付收款人
export function createMultiMchLargeValueBeneficiary(data = {}) {
  return request({
    url: '/merchant-api/disbursement/large/multiMchCreateLargeValueBeneficiary',
    method: 'post',
    data
  })
}

// 多币种查询所有收款人下拉列表
export function fetchMultiMchLargeValueBeneficiaryAllList(params = {}) {
  return request({
    url: '/merchant-api/disbursement/large/queryMultiMchAllBeneficiaryList',
    method: 'get',
    params
  })
}
